import { actionConstants } from '../actions/actionConstants';

const initState = {
  checkDepartmentLicenseOnce: false,
  licenseExpiration: null,
  showLicenseExpirationNotification: false,
  isLogoUpdated: true,
};

export default (state = initState, action) => {
  switch (action.type) {
    case actionConstants.CHECK_DEPARTMENT_LICENSE_ONCE:
      state.checkDepartmentLicenseOnce = action.data;
      return state;
    case actionConstants.SET_LICENSE_EXPIRATION:
      state.licenseExpiration = action.data;
      return state;
    case actionConstants.SHOW_LICENSE_EXPIRATION_NOTIFICATION:
      state.showLicenseExpirationNotification = action.data;
      return state;
    case actionConstants.LOGO_HAS_UPDATED:
      state.isLogoUpdated = action.data;
      return state;
    default:
      return state;
  }
};
